
import { accountState  } from '../legacyStores/account';

export const setAfilliatesAction = (value: []) => {
    accountState.state.affiliates = value;
};

export const selectAffiliateAction = (value: string) => {
    accountState.state.affiliateSelected = value;
};

